export default {
    text: `A new version is available. Please reload your application to enjoy our new features!`,
    button: `Reload`,
};
